import { redactCaptureUrls } from "./lib/analyticsPrivacy";

const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const isCsatRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/csat/");

if (!token && process.env.NODE_ENV === "development") {
  console.error(
    "NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN variable required by PostHog is missing or un-configured, " +
      "this causes events to be silently missed. " +
      "This error stops appearing once NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN is configured",
  );
}

if (token && !isCsatRoute) {
  let initialized = false;
  let interactionTimer: number | undefined;

  const initializePostHog = () => {
    if (initialized) return;
    initialized = true;
    window.removeEventListener("pointerdown", schedulePostHog);
    window.removeEventListener("keydown", schedulePostHog);

    void import("posthog-js").then(async ({ default: posthog }) => {
      (window as unknown as { posthog: typeof posthog }).posthog = posthog;
      posthog.init(token, {
        api_host: "/ingest",
        ui_host: "https://us.posthog.com",
        defaults: "2026-05-30",
        capture_pageview: "history_change",
        capture_performance: { web_vitals: true, network_timing: false },
        capture_exceptions: true,
        capture_dead_clicks: false,
        disable_surveys: true,
        before_send: redactCaptureUrls,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: ".ph-mask, [data-ph-mask]",
        },
        debug: process.env.NODE_ENV === "development",
      });
      const { flushPostHogQueue } = await import("./lib/posthog");
      flushPostHogQueue(posthog);
    });
  };

  function schedulePostHog() {
    if (initialized || interactionTimer !== undefined) return;
    interactionTimer = window.setTimeout(initializePostHog, 1500);
  }

  window.addEventListener("pointerdown", schedulePostHog, { passive: true });
  window.addEventListener("keydown", schedulePostHog);
  window.setTimeout(initializePostHog, 30000);
}
